import CarouselAdComponent from './carousel/CarouselAdComponent';
import VideoAdComponent from './video/VideoAdComponent';
import HeroAdComponent from './hero/HeroAdComponent';
import GalleryAdComponent from './gallery/GalleryAdComponent';
import BasicAdComponent from './basic/BasicAdComponent';

var createNativeComponentRender = function createNativeComponentRender(adtype) {
  switch (adtype) {
    case 'carousel':
    case 'carousel-lead':
      return new CarouselAdComponent(adtype);

    case 'video':
      return new VideoAdComponent();

    case 'hero-ad':
      return new HeroAdComponent();

    case 'photogallery':
      return new GalleryAdComponent();

    default:
      return new BasicAdComponent(adtype);
  }
};

export { createNativeComponentRender as default, createNativeComponentRender };
//# sourceMappingURL=createNativeComponentFactory.js.map